<template>
  <div class="ts-page" :class="{ 'ts-page-safari': isSafari, small: size === 'small' }">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.ts-page {
  background: #ebecf0;
  background-image: linear-gradient(311deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);
  border-radius: 32px;

  display: flex;
  flex-direction: column;

  &.small {
    border-radius: 12px;
  }
}

.ts-page-safari {
  background-image: none;
}
</style>

<script>
export default {
  name: 'TsPage',
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    isSafari() {
      const userAgent = navigator.userAgent;
      return userAgent.indexOf('Safari') > -1;
    }
  }
};
</script>
